import { render } from "./MakeCanvas.vue?vue&type=template&id=4d78b4a5"
import script from "./MakeCanvas.vue?vue&type=script&lang=js"
export * from "./MakeCanvas.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__